import AuthLayout from "layouts/AuthLayout";
import { LoginPage } from "pages/accounts-onboarding/login";
import type { LoginFormModel } from "pages/accounts-onboarding/models";
import React from "react";

const LoginRoute = () => {
	const initialValues: LoginFormModel = {
		email: "",
		password: ""
	};

	return (
		<AuthLayout>
			<LoginPage initialValues={initialValues} />
		</AuthLayout>
	);
};

export default LoginRoute;
